import ScopeConstants from "constants/ScopeConstants"
import { FormActionReducer } from "@gman/gman-redux"

export const SubContractorInvoiceEditListReducer = (
    state = {
        ...FormActionReducer.defaultPageState(),
        ...FormActionReducer.defaultSearchOptions("Number", 10),
        ...FormActionReducer.defaultRecordState()
    },
    action) => {

    if (action.scope === ScopeConstants.SUB_CONTRACTOR_INVOICE_EDIT_LIST) {
        if (action.type === "CHANGE_PAGE_SIZE") {
            return {
                ...state,
                searchOptions: {
                    ...state.searchOptions,
                    pageSize: action.pageSize
                }
            }
        }
        return FormActionReducer.reduce(action, state)
    }

    return state
}